export function UnknownRoutePanel() {
  return (
    <main className="flex h-full items-center justify-center bg-surface text-panelFg">
      <div className="max-w-md rounded-2xl border border-panel bg-panel/60 p-8 text-center shadow-lg">
        <h1 className="mb-2 text-2xl font-semibold">Aldelo File Viewer</h1>
        <p className="text-sm text-muted">
          Shareable file URLs live at <code className="font-mono">/v/&lt;token&gt;</code>.
          Ask whoever is sharing the file to send you the full link.
        </p>
      </div>
    </main>
  );
}
